module.exports = __webpack_public_path__ + "img/view_2.595a693d.svg";